import { Controller } from "stimulus"

// An undo toast for a dismissed "Your next steps" card. Toasts are server-rendered
// and appended to #next-steps-toasts by the dismiss Turbo Stream; each one owns its
// own auto-dismiss timer, so multiple toasts stack and expire independently. Undo
// itself is a Turbo form inside the toast (it removes the toast server-side).
export default class extends Controller {
  // NOTE: Stimulus 2.0 value syntax — `name: Type` only. The `{ type, default }`
  // object form is Stimulus 3.0 and throws here; the default is applied in code.
  static values = { duration: Number }

  connect() {
    this.timer = setTimeout(() => this.element.remove(), this.durationValue || 3500)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }
}
